var contractsLib = {
    factory: "0x0eAC91966b12b81db18f59D8e893b9ccef7e2c30",
    router: "0x54C039C50358B260582fefbDd0E971121394A579",
    dFLR: "0x6f1Be01f9cD0c14E38f94E81Cb281ecB98Cc6A9b",
    activePool: "0x120E3C17afbDFC22fB1acDe15e6577503dD2A54A",
    borrowerOperations: "0x887a70fb340Db210A4629eecC07016b3C5d48E42",
    collSurplusPool: "0x6664433453c2a4dFa77E184a923FC69d459aEc95",
    defaultPool: "0xD7e8B5DFd3737eF430958417Ec406B9Eab9B53D9",
    gasPool: "0x474D9158dE5299AeF59E8Bd37312391543568ec7",
    hintHelpers: "0xBf58BC85f20d714662e7e8AaD41dEeB62839cb3c",
    loansStableSettings: "0x6d69c8B96454DBCb1a5F9AcaF919DBB5d96b3460",
    multiNestGetter: "0xC4C125b46B285AEc299169E29e7Ed7D74689bFB5",
    priceFeed: "0xDE631E16239eB2968194b224722DB86F1F2F3342",
    nestManager: "0xe553bf59398D0b5169886d7A992Cb04940eE93BE",
    sortedNests: "0x622a9D60d79cE598469E111DbCf1C92FD5BAc81B",
    stabilityPool: "0x863eF49F91fC3C7D7F5ebB99bC6aAD118CF3a98B",
    yUSDToken: "0x70Ad7172EF0b131A1428D0c1F66457EB041f2176",
    wflr: "0x02f0826ef6aD107Cfc861152B32B52fD11BaB9ED",
    kakeibo: "0x4D440665EE8313F2235E08D1954ca65B1D9279d2",
    kakeiboLogic: "0xc5Ef66a9096CA58aA35179Cb3dEB5095855d4855",
    dflrStaking: "0x0087d2f95Bdd222D82574CE75cefe5f9F0043902",
};
export default contractsLib;
